module.exports = __webpack_public_path__ + "img/strip.8a673c18.png";